import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import moment from "moment";
import {
	useTable,
	usePagination,
	useSortBy,
	useExpanded,
	useGlobalFilter,
	useRowSelect,
} from "react-table";
// import MainTablePagination from "./MainTablePagination";
import { CARRIERWISE_CONTAINER_REPORT_COLUMN } from "../../columns/CommonColumns";
import { getAllModuleReportData } from "../../../services/dataService";
import { uniqBy, filter, sumBy } from "lodash";
import { exportData } from "../../../utils/helpers";
import Tooltips from "../../Custom Components/tooltip";
import MainTablePaginationAdv from "./MainTablePaginationAdv";
import noDataAvailable from "../../../assets/img/noDataAvailable.png";
import { PulseLoader } from "react-spinners";

function CarrierwiseContainerReport({filteredUserAccessData, type}) {
	const [date, setDate] = useState({
		fromDate: moment().format("YYYY-MM-DD"),
		toDate: moment().add(1, "days").format("YYYY-MM-DD"),
	});
	const [columns] = useState(CARRIERWISE_CONTAINER_REPORT_COLUMN);
	const [tableData, setTableData] = useState([]);
	const [noDataState, setNoDataState] = useState(false);
	const [loading, setLoading] = useState(false);

	var allowToDownload =
	filter(filteredUserAccessData, { DownLoad: 1 }).length > 0;

	useEffect(() => {
		var newCarrierForTractor = [];
		var newCarrierForAggregate = [];
		var newCarrierFor5M = [];
		var newDataOfTractor = [];
		var newDataOfAggregate = [];
		var newDataOf5M = [];
		var newContainerCount = [];
		var dataArray = [];
		async function getAllShipmentList() {
			if(type === "Carrier"){
				try {
					setLoading(true);
					setNoDataState(false);
					const response = await getAllModuleReportData(date);

					const tractorFilter = filter(response.data, { DataOf: "TRACTOR" });
					const aggregateFilter = filter(response.data, { DataOf: "AGGREGATE" });
					const five_M_Filter = filter(response.data, { DataOf: "5M" });

					const uniqCarrierForTractor = uniqBy(tractorFilter, "Carrier");
					const uniqCarrierForAggregate = uniqBy(aggregateFilter, "Carrier");
					const uniqCarrierFor5M = uniqBy(five_M_Filter, "Carrier");

					for (let i = 0; i < uniqCarrierForTractor.length; i++) {
						newCarrierForTractor.push(uniqCarrierForTractor[i].Carrier);
						newDataOfTractor.push(uniqCarrierForTractor[i].DataOf);
					}
					for (let i = 0; i < uniqCarrierForAggregate.length; i++) {
						newCarrierForAggregate.push(uniqCarrierForAggregate[i].Carrier);
						newDataOfAggregate.push(uniqCarrierForAggregate[i].DataOf);
					}
					for (let i = 0; i < uniqCarrierFor5M.length; i++) {
						newCarrierFor5M.push(uniqCarrierFor5M[i].Carrier);
						newDataOf5M.push(uniqCarrierFor5M[i].DataOf);
					}

					for (let j = 0; j < newCarrierForTractor.length; j++) {
						const filteredCarrier = filter(tractorFilter, {
							Carrier: newCarrierForTractor[j],
						});
						const containerCountSummation = sumBy(
							filteredCarrier,
							function (item) {
								return item.Container_Count;
							}
						);
						newContainerCount.push(containerCountSummation);
					}
					for (let j = 0; j < newCarrierForAggregate.length; j++) {
						const filteredCarrier = filter(aggregateFilter, {
							Carrier: newCarrierForAggregate[j],
						});
						const containerCountSummation = sumBy(
							filteredCarrier,
							function (item) {
								return item.Container_Count;
							}
						);
						newContainerCount.push(containerCountSummation);
					}
					for (let j = 0; j < newCarrierFor5M.length; j++) {
						const filteredCarrier = filter(five_M_Filter, {
							Carrier: newCarrierFor5M[j],
						});
						const containerCountSummation = sumBy(
							filteredCarrier,
							function (item) {
								return item.Container_Count;
							}
						);
						newContainerCount.push(containerCountSummation);
					}
					var concatNewCarrier = [].concat(
						newCarrierForTractor,
						newCarrierForAggregate,
						newCarrierFor5M
					);
					var concatNewDataOf = [].concat(
						newDataOfTractor,
						newDataOfAggregate,
						newDataOf5M
					);
					for (let k = 0; k < concatNewCarrier.length; k++) {
						if (concatNewCarrier[k]) {
							const tableRow = {
								DataOf: concatNewDataOf[k],
								Carrier: concatNewCarrier[k],
								Container_Count: newContainerCount[k],
							};

							dataArray.push(tableRow);
						}
					}
					setLoading(false);
					setTableData(dataArray);
				} catch (error) {
					setTableData([]);
					if (error.response.data.StatusCode === 404) {
						setNoDataState(true);
					}
					setLoading(false);
				}
			}
		}
		getAllShipmentList();
	}, [date, type]);

	useEffect(() => {
		if (moment(date.fromDate).isAfter(date.toDate)) {
			alert("From date should not be after of To date");
		}
	}, [date]);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		state,
		setPageSize,
		canPreviousPage,
		setGlobalFilter,
		prepareRow,
	} = useTable(
		{
			columns,
			data: tableData,
			autoResetPage: false,
			initialState: { pageSize: 50 },
			autoResetExpanded: false,
			autoResetGlobalFilter: false,
		},
		useGlobalFilter,
		useSortBy,
		useExpanded,
		usePagination,
		useRowSelect
	);

	const { pageIndex, pageSize, globalFilter } = state;

	function downloadHandler() {
		exportData(
			tableData.map((item) => {
				return {
					MODULE_NAME: item["DataOf"],
					CARRIER: item["Carrier"],
					CONTAINER_COUNT: item["Container_Count"],
				};
			}),
			`Carrierwise Container Report - from-${date.fromDate} to-${date.toDate}`
		);
	}

	return (
		<>
			{/* <div className="table_actions">
        <Form.Group>
          <Form.Control
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="portwise_report_search"
            placeholder="search here.."
          />

          <Button
            className="portwise_report_excel_download"
            onClick={downloadHandler}
          >
            <i className="bx bxs-download"></i>
          </Button>

          <Form.Label className="portwise_report_fromDate_label">
            From-
          </Form.Label>
          <Form.Control
            type="date"
            className="portwise_report_fromDate"
            value={date.fromDate}
            onChange={(e) => setDate({ ...date, fromDate: e.target.value })}
            name="fromDate"
          />

          <Form.Label className="portwise_report_toDate_label">To-</Form.Label>
          <Form.Control
            type="date"
            className="portwise_report_toDate"
            value={date.toDate}
            onChange={(e) => setDate({ ...date, toDate: e.target.value })}
            name="toDate"
          />
        </Form.Group>
        <Button
          className="portwise_report_excel_download"
          onClick={downloadHandler}
        >
          <i className="bx bxs-download"></i>
        </Button>
      </div> */}
			{loading && (
				<PulseLoader
					color="#007bff"
					size="20px"
					margin="10px"
					style={{ position: "absolute", top: "50vh", left: "45%" }}
				/>
			)}
			{noDataState && (
				<img
					src={noDataAvailable}
					alt="notAvailableImg"
					// width="630px"
					// height="630px"
					className="noDataFoundImg"
					// style={{marginLeft:"-2%"}}
				/>
			)}
			<div
				style={{
					display: "flex",
					flexWrap: "wrap",
					marginBottom: "-35px",
					position: "absolute",
					top: "80px",
					float: "right",
					width: "620px",
					right: "20px",
				}}
			>
				<div
					style={{
						display: "flex",
						justifyContent: "space-around",
						marginLeft: "0",
						width: "100%",
					}}
				>
					<div style={{ float: "left" }}>
						<Form.Control
							value={globalFilter || ""}
							onChange={(e) => setGlobalFilter(e.target.value)}
							className="portwise_report_search"
							placeholder="search here.."
						/>
					</div>
					<div
						style={{
							display: "flex",
							width: "200px",
							alignItems: "center",
							marginLeft: "10px",
							fontWeight: "500",
						}}
					>
						<div>From-</div>
						<Form.Control
							type="date"
							// className="portwise_report_fromDate"
							value={date.fromDate}
							onChange={(e) => {
								if(e.target.value <= date.toDate){
									setDate({ ...date, fromDate: e.target.value })
								}else{
									setDate({ ...date, fromDate: date.fromDate })
									alert('From date should not greater than To date.')
								}
							}}
							name="fromDate"
						/>
					</div>
					<div
						style={{
							display: "flex",
							width: "200px",
							alignItems: "center",
							marginLeft: "10px",
							fontWeight: "500",
						}}
					>
						<div>To-</div>
						<Form.Control
							type="date"
							// className="portwise_report_toDate"
							value={date.toDate}
							onChange={(e) => {
								if(e.target.value >= date.fromDate){
									setDate({ ...date, toDate: e.target.value })
								}else{
									setDate({ ...date, toDate: date.toDate })
									alert('To date should not lesser than From date.')
								}
							}}
							name="toDate"
						/>
					</div>
					{allowToDownload && (<Tooltips content={"Download"} direction="down">
						<button
							className="portwiseReport__download"
							onClick={downloadHandler}
						>
							<i
								class="bx bxs-download"
								style={{ transform: "scale(1.5)" }}
							></i>
						</button>
					</Tooltips>)}
				</div>
			</div>

			{!noDataState && (
				<>
					<div className="table_container">
						<table {...getTableProps()} className="tables mtbs">
							<thead>
								{headerGroups.map((headerGroup) => (
									<tr {...headerGroup.getHeaderGroupProps()}>
										{headerGroup.headers.map((column) => (
											<th
												{...column.getHeaderProps(
													column.getSortByToggleProps()
												)}
												className="portwise_report_thead_th"
											>
												{column.render("Header")}
												<i
													className={
														column.isSorted
															? column.isSortedDesc
																? "fi fi-rr-angle-small-down head-icon"
																: "fi fi-rr-angle-small-up head-icon"
															: "fi fi-rr-circle-small head-icon w"
													}
												></i>
											</th>
										))}
									</tr>
								))}
							</thead>
							<tbody {...getTableBodyProps()}>
								{page.map((row) => {
									prepareRow(row);
									return (
										<tr {...row.getRowProps()}>
											{row.cells.map((cell) => {
												return (
													<td
														{...cell.getCellProps()}
														className={
															cell.row.subRows.length !== 0
																? "main-row portwise_report_tbody_td"
																: "sub-row portwise_report_tbody_td"
														}
														// style={{textAlign:"center"}}
													>
														<div className="cell-wrap">
															{cell.render("Cell")}
														</div>
													</td>
												);
											})}
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
					{/* <MainTablePagination
        nextPage={nextPage}
        previousPage={previousPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canPreviousPage={canPreviousPage}
        setPageSize={setPageSize}
      /> */}
					<MainTablePaginationAdv
						nextPage={nextPage}
						previousPage={previousPage}
						canNextPage={canNextPage}
						pageIndex={pageIndex}
						pageOptions={pageOptions}
						pageSize={pageSize}
						canPreviousPage={canPreviousPage}
						setPageSize={setPageSize}
						gotoPage={gotoPage}
						pageCount={pageCount}
					/>
				</>
			)}
		</>
	);
}
export default CarrierwiseContainerReport;
